<i18n>
{
  "ru":{
    "invoice": "Счет",
    "field_due_amt": "К оплате",
    "ad_hoc_name": "Имя Товара",
    "ad_hoc_amount": "Цена Товара",
    "ad_hoc_total": "Всего",
    "pay_invoice": "Оплатить Счет"
  },
  "en":{
    "invoice": "Invoice",
    "field_due_amt": "Amount due",
    "ad_hoc_name": "Item Name",
    "ad_hoc_amount": "Item Price",
    "ad_hoc_total": "Item Total",
    "pay_invoice": "Pay Invoice Now"
  }
}
</i18n>
<template>
  <el-dialog :close-on-click-modal="false"
    custom-class="webpay"
    :visible.sync="visibleInner"
    top="1vh"
    append-to-body
  >
    <pay-modal
      v-if="showPayModal"
      :visible.sync="showPayModal"
      :url="common.url_pay"
      :callback="paymentFinished"
    ></pay-modal>
    <section v-loading="loading" class="pa-1">
      <div class="ma-3">
        <div class="aligner right">
          <b>{{ st.site_name }}</b>
        </div>
        <div class="aligner right">
          <i>{{ st.site_address1 }}</i>
        </div>
        <div class="aligner right">
          <i>{{ st.site_city }}, {{ st.site_state }} {{ st.site_zip }}</i>
        </div>
        <div class="aligner right">
          <i>{{ st.country_name }}</i>
        </div>
      </div>

      <hr />
      <div class="aligner left ma-3">
        <b>{{ $t("invoice") }} #{{ invoice.name }}</b>
      </div>

      <section v-if="account" class="ma-3">
        <div class="aligner left">{{ account.company }}</div>
        <div class="aligner left">
          {{ account.first_name }} {{ account.last_name }}
        </div>
        <div class="aligner left">{{ account.address1 }}</div>
      </section>

      <el-row class="ma-3">
        <el-table border :data="items" style="width: 100%">
          <!-- <el-table-column type="expand">
          <template slot-scope="props">
            <div v-if="props.row.res">
              <p v-for="(value, key) in props.row.res" :key="key">
                {{key}}: {{value}}
              </p>
            </div>
          </template>
          </el-table-column>-->
          <el-table-column :label="$t('ad_hoc_name')" prop="name">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.name }}</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('ad_hoc_amount')" prop="price">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.price }}</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('quantity')" prop="qty">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.qty }}</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('ad_hoc_total')" prop="total">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.total }}</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <el-row class="aligner right ma-3">
        <table cellpadding="3">
          <tr>
            <td>{{ $t("field_due_date") }}:</td>
            <td align="right">{{ invoice.due_date }}</td>
          </tr>
          <tr v-if="invoice.po_name">
            <td>{{ $t("po_name") }} #:</td>
            <td align="right">{{ invoice.po_name }}</td>
          </tr>
          <tr>
            <td>{{ $t("field_total_amt") }}:</td>
            <td align="right">{{ common.total }}</td>
          </tr>
          <tr>
            <td>{{ $t("amount_paid") }}:</td>
            <td align="right">
              <span v-if="common.amt_paid_f">{{ common.amt_paid_f }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t("field_billing_status") }}:</b>
            </td>
            <td align="right">{{ common.amt_due }}</td>
          </tr>
        </table>
      </el-row>

      <el-row class="ma-3" v-if="invoice.notes">
        <div>{{ $t("notes") }}</div>
        {{ invoice.notes }}
      </el-row>

      <el-row class="aligner right">
        <el-button
          v-if="amtValue"
          :disabled="!common.url_pay || !common.is_available_to_pay"
          round
          type="primary"
          plain
          @click="pay"
          >{{ $t("pay_invoice") }}</el-button
        >
      </el-row>
    </section>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'
import PayModal from '../payments/PayModal'

export default {
  name: 'invoice-show-modal',
  props: ['visible', 'url'],
  components: {
    'pay-modal': PayModal
  },
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    },
    amtValue () {
      return this.common && this.common.amt_due ? parseFloat(this.common.amt_due.replace(/[^0-9.]/g, '')) : 0
    }
  },
  data: () => ({
    loading: true,
    showPayModal: false,
    invoice: {},
    st: {},
    account: {},
    items: [],
    common: {}
  }),
  created () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      apiRes.post(this.url, { json: true }).then(data => {
        let vars = data.page_vars
        if (vars) {
          this.st = vars.st
          this.invoice = vars.invoice
          this.account = vars.account
          this.items = vars.items
          this.common = {
            amt_paid_f: vars.amt_paid_f,
            amt_due: vars.amt_due,
            total: vars.total,
            url_pay: vars.url_pay,
            is_available_to_pay: vars.is_available_to_pay
          }
        }

        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    pay () {
      this.showPayModal = true
    },
    paymentFinished () {
      this.load()
    }
  }
}
</script>

<style>
.el-dialog.webpay.refund h4 {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: left;
  color: #c1c1c1;
  padding: 0;
}

.el-dialog.webpay.refund {
  max-width: 532px;
}
</style>
